// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"styles-module__modal-body___2aERM"};